export const HTTP_MESSAGE_HEADER = {
  LicenseViolationMsg: 'LicenseViolationMsg',
} as const;
